import { ReactNode } from 'react'
import { useAuthStore, UserRole } from '@store/useAuthStore'
import { ForbiddenPage } from '@pages/ForbiddenPage'

interface RoleProtectedRouteProps {
  readonly children: ReactNode
  readonly allowedRoles: UserRole[]
}

export function RoleProtectedRoute({ children, allowedRoles }: Readonly<RoleProtectedRouteProps>) {
  const { isAuthenticated, getRole, checkTokenExpiry, user } = useAuthStore()

  // Verificar se está autenticado
  if (!isAuthenticated) {
    return null // Redirecionado pelo ProtectedLayout (ex.: / ou /login)
  }

  // Verificar expiração do token
  const isTokenValid = checkTokenExpiry()
  if (!isTokenValid) {
    return null // Token expirado, será redirecionado
  }

  // Obter role do usuário - tentar múltiplas formas
  let userRole = getRole()
  
  // Se não conseguiu obter role, tentar derivar do functionId
  if (!userRole && user?.functionId) {
    if (user.functionId === 1) userRole = 'receptionist'
    else if (user.functionId === 2) userRole = 'mechanic'
    else if (user.functionId >= 3) userRole = 'administrator'
  }

  // Debug em desenvolvimento
  if (import.meta.env.DEV) {
    console.log('[RoleProtectedRoute]', {
      userRole,
      allowedRoles,
      userFunctionId: user?.functionId,
      isAllowed: userRole && allowedRoles.includes(userRole)
    })
  }

  // Verificar se o usuário tem uma das roles permitidas
  if (!userRole || !allowedRoles.includes(userRole)) {
    return <ForbiddenPage />
  }

  return <>{children}</>
}
